import angular from 'angular';

angular.module('commonServices').filter('similar', function() {
  var levenshteinenator = function(a, b) {
    var cost;
    var m = a.length;
    var n = b.length;

    // make sure a.length >= b.length to use O(min(n,m)) space, whatever that is
    if (m < n) {
      var c = a;
      a = b;
      b = c;
      var o = m;
      m = n;
      n = o;
    }

    var r = [];
    r[0] = [];
    for (var c = 0; c < n + 1; ++c) {
      r[0][c] = c;
    }

    for (var i = 1; i < m + 1; ++i) {
      r[i] = [];
      r[i][0] = i;
      for (var j = 1; j < n + 1; ++j) {
        cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        r[i][j] = minimator(r[i - 1][j] + 1, r[i][j - 1] + 1, r[i - 1][j - 1] + cost);
      }
    }

    return r;
  };

  /**
   * Return the smallest of the three numbers passed in
   * @param Number x
   * @param Number y
   * @param Number z
   * @return Number
   */
  var minimator = function(x, y, z) {
    if (x <= y && x <= z) return x;
    if (y <= x && y <= z) return y;
    return z;
  };

  var similar = function(value, value2, max) {
    if (!value || !value2) return false;
    if (value.toLowerCase().indexOf(value2.toLowerCase()) !== -1) return true;
    var distArray = levenshteinenator(value, value2);
    var dist = distArray[distArray.length - 1][distArray[distArray.length - 1].length - 1];
    return dist <= max;
  };

  return function(input, search, maxDistance) {
    maxDistance = maxDistance || 3;
    if (angular.isArray(input)) {
      if (!search) return input;
      var result = [];
      angular.forEach(input, function(value) {
        if (typeof value === 'object') {
          for (var property in value)
            if (value.hasOwnProperty(property) && similar(value[property], search, maxDistance)) {
              result.push(value);
              break;
            }
        } else if (similar(value, search, maxDistance)) {
          result.push(value);
        }
      });
      return result;
    } else if (typeof input === 'object') {
      if (!search) return input;
      var result = {};
      angular.forEach(input, function(value, key) {
        if (similar('' + key, search, maxDistance)) {
          result[key] = value;
        } else if (
          typeof value === 'string' &&
          (('' + value).toLowerCase().indexOf(search.toLowerCase()) !== -1 ||
            similar('' + value, search, maxDistance))
        ) {
          result[key] = value;
        }
      });
      return result;
    } else {
      return similar(input, search, maxDistance);
    }
  };
});
